// @flow
import omitEmptyFields from 'mz-utils/omitEmptyFields'
import client from '../../client'
import format from '../../utils/format'

// Types
export type Data = {
  id: string,
  currency: string,
  first_name: string,
  last_name: string,
}

// Constants
export const GET_GBT_SEGMENTS_ENDPOINT = '/corporate/gbt/payloads/{0}/segments/'

/**
 * Get GBT segments for a payload
 * @param {Object} data Segment information
 * @param {string} data.id Segment ID
 * @return {Promise|Error} A resolved Promise with the server response or Rejected with an Error
 */
export const getGBTSegments = (data: Data): Promise<any> => {
  const endpoint = format(GET_GBT_SEGMENTS_ENDPOINT, data.id)
  const params = omitEmptyFields({
    currency: data.currency,
    first_name: data.first_name,
    last_name: data.last_name,
  })

  return client.get(endpoint, {
    query: params,
  })
}

export default getGBTSegments
